import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  contractInfos() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          contractInfos {
            id,
            contract_pdf_url,
            proposal_pdf_url,
            contract_signed_at,
            contract_subscriber_ip
          }
        }
      `
    })
  },
  signContract() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          signContract
        }
      `
    })
  }
}
